import { render, staticRenderFns } from "./UploadLomLogo.vue?vue&type=template&id=6d21e68c"
import script from "./UploadLomLogo.vue?vue&type=script&lang=js"
export * from "./UploadLomLogo.vue?vue&type=script&lang=js"
import style0 from "./UploadLomLogo.vue?vue&type=style&index=0&id=6d21e68c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports